module.exports = __webpack_public_path__ + "img/sm_04_insta.ed21f772.svg";